import React from "react";
import locale from "@bonliva-crm/locale";
import { FilterWithFavouriteProps } from "../utils/filters-record-types";
import { MultiSelectFilter } from "./_common/multi-select-filter";

type Option = { label: string; value: string | null };

export type StatusFilterProps = {
  options: Option[];
  label?: string;
} & FilterWithFavouriteProps;

export const StatusFilter = ({ label, options, ...props }: StatusFilterProps) => {
  const title = label ?? locale.kitTableColumnType.KitStatus;

  return <MultiSelectFilter label={title} options={options} {...props} />;
};
